import React, { useState, useMemo } from "react";
import _ from "lodash";
import { Grid, Card, Progress, Accordion, Icon, Header, Button } from "semantic-ui-react";

export default function WeeksTimeline({ data = {} }) {
  // normalize data into [{ year, weeks: [{week, value}] }]

  const getWeekStartDate = (year, week, startOnMonday = true) => {
    const simple = new Date(year, 0, 1 + (week - 1) * 7);
    const dow = simple.getDay(); // 0=Sun, 1=Mon, etc
    const ISOweekStart = new Date(simple);
    const adjust = startOnMonday ? (dow <= 1 ? dow - 1 : dow - 8) : -dow;
    ISOweekStart.setDate(simple.getDate() - adjust);
    return ISOweekStart.toDateString(); // e.g. "Mon Jan 08 2024"
  };

  const years = useMemo(() => {
    return _(data)
      .toPairs() // [[year, {week1:9,...}], ...]
      .map(([year, weeks]) => ({
        year: Number(year),
        weeks: _(weeks)
          .toPairs() // [["week1", 9], ...]
          .map(([key, value]) => ({
            week: Number(key.replace("week", "")),
            value,
          }))
          .sortBy("week") // <-- ensure sorted by week number
          .value(),
      }))
      .sortBy("year")
      .value();
  }, [data]);

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) =>
    setActiveIndex((prev) => (prev === index ? null : index));

  return (
    <div style={{ padding: 20 }}>
      <Header as="h2" dividing>
        Weekly Overview
      </Header>

      <Accordion fluid styled>
        {years.map(({ year, weeks }, yearIdx) => {
          const avg = _.meanBy(weeks, "value") || 0;
          const maxVal = _.maxBy(weeks, "value")?.value || 0;

          return (
            <React.Fragment key={year}>
              <Accordion.Title
                active={activeIndex === yearIdx}
                index={yearIdx}
                onClick={() => toggleAccordion(yearIdx)}
              >
                <Icon name="dropdown" />
                {year} &nbsp; • &nbsp; {weeks.length} weeks &nbsp; • &nbsp; Avg:{" "}
                {Math.round(avg)} &nbsp; • &nbsp; Max: {maxVal}
              </Accordion.Title>

              <Accordion.Content active={activeIndex === yearIdx}>
                <Grid stackable doubling columns={7}>
                  {weeks.map(({ week, value }) => (
                    <Grid.Column key={week}>
                      <Card fluid>
                        <Card.Content>
                          <Card.Header>Week {week}</Card.Header>
                          <Card.Meta>Date: {getWeekStartDate(year, week, true)}</Card.Meta>
                          <Card.Meta>Value: {value}</Card.Meta>
                          <Progress
                            percent={Math.min(value, 100)}
                            progress
                            indicating
                          />
                        </Card.Content>
                      </Card>
                    </Grid.Column>
                  ))}
                </Grid>
              </Accordion.Content>
            </React.Fragment>
          );
        })}
      </Accordion>
    </div>
  );
}
